import { Theme } from '@mui/material';
/**
 * Styling for ccf-editor-toolbar
 * @returns ccf-editor-toolbar CSS properties as a JSON object
 * @example ccfEditorToolbarStyles(theme)
 */
export const ccfEditorToolbarStyles = (theme: Theme) => {
  const styles = {
    toolbarContainer: {
     display: 'flex',
     flexWrap: 'wrap', 
     gap: '7px'
    },
    buttonActive: {
      background: theme?.palette?.background?.main,
      marginRight: '0.2rem',
    },
    button: {
      color: `${theme.palette.grey[800]}`,
      minWidth: '34px',
      '&:hover': {
        backgroundColor: `${theme.palette.action.hover}`,
      },
      padding: 0,
    },
    toolbar: {
      display: 'block',
      width: '100%',
      borderBottom: 'none',
    },
    linkBox: {
      width: '20vw',
      backgroundColor: '#f4f4f4',
      marginTop: '2px',
    },
    btnCheck: {
      verticalAlign: 'middle',
    },
    btnContainer: {
      color: `${theme.palette.grey[800]}`,
      'min-width': '2.188rem', 
      padding: 0,
    },
    modalContainer:{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'background.paper',
      border: `0.063rem solid ${theme?.palette?.border?.dark}`, 
      borderRadius: '0.313rem', 
      boxShadow: '24',
      padding: '1.5rem', 
      fontSize: '0.813rem', 
      [theme.breakpoints.down(500)]: {
        width: '21.25rem',
        fontSize: theme?.typography?.h6?.fontSize,
      },
    },
    modalContentContainer: {
      display: 'flex',
      width: '100%',
    },
    modalContent: {
      '> :not(:first-of-type)': {
        marginTop: '0.7rem',
      },
      width: '100%',
      overflow: 'auto',
      wordBreak: 'break-word',
    },
    title: {
      fontSize: '1.25rem', 
      fontWeight: 600,
      [theme.breakpoints.down(500)]: {
        fontSize:  '1rem', 
      },
      marginBottom:'1rem',
    },
    inputdiv: {
      display: 'flex',
      justifyContent:'space-between',
    },
    closeButtonColumn: {
      fontSize: '1.25rem', 
      display: 'flex',
      alignItems: 'baseline',
      '> button': {
        padding: 0,
      },
    },
    buttonsContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: '1.5rem',
      '> :not(:first-of-type)': {
        marginLeft: '0.5rem', 
      },
      button:{
        width:'4.375rem',
        height: '1.875rem',
        fontSize: 'inherit',
      },
    },
    inputBtn: {
      '& input[type=number]': {
        '-moz-appearance': 'textfield',
      },
      '& input[type=number]::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0,
      },
      '& input[type=number]::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0,
      },
    },
    icon: {
      fontSize: '22px',
      marginRight: '-4px',
    },
    table: {
      marginTop :'-5px'
    },
  };
  return styles;
};

export default ccfEditorToolbarStyles;